import interpolateComponents from '@automattic/interpolate-components';
import type { JSX } from 'react';
import { sprintf } from 'sprintf-js';

import type { I18nFn } from './types/I18nFn';

export function createI18nFnForLocale(locale: UserLocale): I18nFn {
  return (text, ...dataArguments) => {
    const translatedText = getTranslatedText(locale, text);
    if (dataArguments.length === 0) return translatedText;

    const [data] = dataArguments;

    const keys = Object.keys(data) as unknown as (keyof typeof data)[];
    if (keys.length === 0) return translatedText;

    const args: Record<string, string | number> = {};
    const components: Record<string, JSX.Element> = {};

    for (const key of keys) {
      const value = data[key];

      if (typeof value === 'string' || typeof value === 'number')
        args[key] = value;
      else components[key] = value;
    }

    const translatedTextWithArgs = sprintf(translatedText, args);

    const hasComponents = Object.keys(components).length > 0;
    if (!hasComponents) return translatedTextWithArgs;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return interpolateComponents({
      mixedString: translatedTextWithArgs,
      components,
    });
  };
}
